import { ServiceItemPaymentStatus, PatientServiceItem, PatientServiceItemStatus, PatientServiceItemType, PaymentTypeName } from '@uplift/api';
import { AppointmentState } from '@uplift/types';
import { MoneyCents, FlexTableColumn, TableCellDateOrDateTime } from '@uplift/ui-v2';
import { CompletedServiceItemPaymentAmount, ServiceItemPaymentAmount } from './ServiceItemPaymentAmount.component';
import { Typography } from '@mui/material';


export const isServiceItemCanceled = (row: PatientServiceItem) => {
  return (
    (
      row.serviceType === PatientServiceItemType.appointment
      && row.service.appointment.state === AppointmentState.cancelled
    )
    || row.payment?.status === ServiceItemPaymentStatus.canceled
  );
};


const paymentsBaseColumns = [
  {
    field: 'serviceDate',
    headerName: 'Date of Service',
    sortable: false,
    renderCell: ({ value, row }) => {
      if (isServiceItemCanceled(row)) {
        return (
          <span style={{ textDecoration: 'line-through' }}>
            <TableCellDateOrDateTime value={value} />
          </span>
        );
      }
      return <TableCellDateOrDateTime value={value} />;
    },
    flex: 1,
  } as FlexTableColumn<PatientServiceItem, 'serviceDate'>,
  {
    field: 'provider',
    headerName: 'Provider',
    sortable: false,
    renderCell: ({ row }) => {
      return <span>{row.provider.name}</span>;
    },
    width: '240px' as unknown as number,
    minWidth: '0px' as unknown as number,
    maxWidth: '100%' as unknown as number,
  } as FlexTableColumn<PatientServiceItem, 'provider'>,
  {
    field: 'payment',
    headerName: 'Payment',
    sortable: false,
    renderCell: ({ row }) => {
      if (!row.payment || row.payment?.status === ServiceItemPaymentStatus.canceled) {
        return (
          <Typography variant="body2" color="textPrimary">N/A</Typography>
        );
      } else if (row.payment.type === PaymentTypeName.cash) {
        return (
          <Typography variant="body2" color="textPrimary">Self pay</Typography>
        );
      } else if (row.payment.type === PaymentTypeName.insurance && row.payment.insuranceName) {
        return (
          <span>
            <Typography variant="body2" color="textPrimary">{row.payment.insuranceName}</Typography>
            {row.payment.secondaryInsuranceName && <Typography variant="body2">+{row.payment.secondaryInsuranceName}</Typography>}
          </span>
        );
      }

      return ' ';
    },
    flex: 1,
  } as FlexTableColumn<PatientServiceItem, 'payment'>,
];


export const outstandingPaymentsDesktopColumns = [
  ...paymentsBaseColumns,
  {
    field: 'payment',
    headerName: 'Amount Due',
    sortable: false,
    flex: 1,
    align: 'right',
    renderCell: ({ row }) => {
      if (row.payment?.type === PaymentTypeName.insurance && [ PatientServiceItemStatus.processing ].includes(row.status)) {
        return <span>TBD</span>;
      }

      if (!row.payment) {
        return <span>No charge</span>;
      }

      if (!row.payment.payment?.amountCents) {
        return <span>No charge</span>;
      }

      return (
        <strong><MoneyCents value={row.payment.payment?.amountCents} /></strong>
      );
    },
  } as FlexTableColumn<PatientServiceItem, 'payment'>,
];


export const processingPaymentsDesktopColumns = [
  ...paymentsBaseColumns,
  {
    field: 'payment',
    headerName: 'Amount Due',
    sortable: false,
    flex: 1,
    align: 'right',
    renderCell: ServiceItemPaymentAmount,
  } as FlexTableColumn<PatientServiceItem, 'payment'>,
];


export const completedPaymentsDesktopColumns = [
  ...paymentsBaseColumns,
  {
    field: 'payment',
    headerName: 'Amount Paid',
    sortable: false,
    flex: 1,
    align: 'right',
    renderCell: CompletedServiceItemPaymentAmount,
  } as FlexTableColumn<PatientServiceItem>,
];
